module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grid_highlight_red.88228856.png";